// Directly reference and pull in styling from stub,
// that is commented out in production to elimited 'fake'
// stub javascript while having single source of truth for LESS
require("../../stubs/hcuGlossaryTerm/hcuGlossaryTerm.less");


// WEBPACK FOOTER //
// ./src/pages/hcu/hcuGlossaryTerm/hcuGlossaryTerm.js